import { CircularProgress, GridLegacy, Stack, Tooltip } from '@mui/material';
import SegmentInlineFieldButton from 'ui-component/Segment/SegmentInlineFieldButton';
import SegmentIconButton from 'ui-component/Segment/SegmentIconButton';
import {
  IconArrowBackUp,
  IconDeviceFloppy,
  IconInfoCircle,
  IconX,
} from '@tabler/icons-react';
import { ReactElement } from 'react';
import { PermissionScope } from 'types/apps';
import { useFeature } from '@growthbook/growthbook-react';
import { FeatureFlags } from 'types';

type BaseCellWithInputProps = {
  clonedInputElement: ReactElement;
  isLoading?: boolean;
  permissionScope?: PermissionScope;
  handleStopEdit: () => void;
  tooltip?: string;
};

const BaseCellWithInput = ({
  clonedInputElement,
  isLoading,
  permissionScope,
  handleStopEdit,
  tooltip,
}: BaseCellWithInputProps) => {
  const tempClickOffInlineEdit = useFeature(
    FeatureFlags.tempClickOffInlineEdit
  ).on;

  return (
    <GridLegacy
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      sx={{ flexWrap: 'nowrap' }}
    >
      <GridLegacy item xs="auto">
        <Stack alignItems="center" direction="row">
          {clonedInputElement}
          {!tempClickOffInlineEdit && (
            <SegmentInlineFieldButton
              loading={isLoading}
              type="submit"
              color="primary"
              permissionScope={permissionScope}
              style={{ backgroundColor: 'white' }}
            />
          )}
          {!!tempClickOffInlineEdit && (
            <GridLegacy item xs="auto">
              {isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <SegmentIconButton
                  color="primary"
                  type="submit"
                  size="small"
                  permissionScope={permissionScope}
                  tooltip="Save value"
                >
                  <IconDeviceFloppy stroke="1.5px" width={20} height={20} />
                </SegmentIconButton>
              )}
            </GridLegacy>
          )}
          {tooltip !== null && tooltip !== undefined && (
            <Tooltip title={tooltip}>
              <IconInfoCircle />
            </Tooltip>
          )}
        </Stack>
      </GridLegacy>
      <GridLegacy item xs="auto">
        <SegmentIconButton
          color="error"
          onClick={handleStopEdit}
          size="small"
          permissionScope={permissionScope}
          sx={{
            backgroundColor: 'white',
            '&:hover': {
              backgroundColor: 'white',
            },
          }}
          tooltip={
            tempClickOffInlineEdit
              ? 'Exit editing without saving changes'
              : 'Exit Edit'
          }
        >
          {tempClickOffInlineEdit ? (
            <IconArrowBackUp stroke="1.5px" width={20} height={20} />
          ) : (
            <IconX stroke="1.5px" width={20} height={20} />
          )}
        </SegmentIconButton>
      </GridLegacy>
    </GridLegacy>
  );
};

export default BaseCellWithInput;
